<div class="cb-vertical-navigation-wrapper">

    <!-- Header -->
    <div class="cb-vertical-navigation-header">
        <ng-content select="[bxVerticalNavigationHeader]"></ng-content>
    </div>

    <!-- Content -->
    <div
        class="cb-vertical-navigation-content"
        cbScrollbar
        [cbScrollbarOptions]="{wheelPropagation: inner, suppressScrollX: true}"
        #navigationContent>

        <!-- Content header -->
        <div class="cb-vertical-navigation-content-header">
            <ng-content select="[bxVerticalNavigationContentHeader]"></ng-content>
        </div>

        <!-- Items -->
        <ng-container *ngFor="let item of navigation; trackBy: trackByFn">

            <!-- Skip the hidden items -->
            <ng-container *ngIf="(item.hidden && !item.hidden(item)) || !item.hidden">

                <!-- Aside -->
                <cb-vertical-navigation-aside-item
                    *ngIf="item.type === 'aside'"
                    [item]="item"
                    [name]="name"
                    [activeItemId]="activeAsideItemId"
                    [autoCollapse]="autoCollapse"
                    [skipChildren]="true"
                    (click)="toggleAside(item)"></cb-vertical-navigation-aside-item>

                <!-- Basic -->
                <cb-vertical-navigation-basic-item
                    *ngIf="item.type === 'basic'"
                    [item]="item"
                    [name]="name"></cb-vertical-navigation-basic-item>

                <!-- Collapsable -->
                <cb-vertical-navigation-collapsable-item
                    *ngIf="item.type === 'collapsable'"
                    [item]="item"
                    [name]="name"
                    [autoCollapse]="autoCollapse"></cb-vertical-navigation-collapsable-item>

                <!-- Divider -->
                <cb-vertical-navigation-divider-item
                    *ngIf="item.type === 'divider'"
                    [item]="item"
                    [name]="name"></cb-vertical-navigation-divider-item>

                <!-- Group -->
                <cb-vertical-navigation-group-item
                    *ngIf="item.type === 'group'"
                    [item]="item"
                    [name]="name"
                    [autoCollapse]="autoCollapse"></cb-vertical-navigation-group-item>

                <!-- Spacer -->
                <cb-vertical-navigation-spacer-item
                    *ngIf="item.type === 'spacer'"
                    [item]="item"
                    [name]="name"></cb-vertical-navigation-spacer-item>

            </ng-container>

        </ng-container>

        <!-- Content footer -->
        <div class="cb-vertical-navigation-content-footer">
            <ng-content select="[bxVerticalNavigationContentFooter]"></ng-content>
        </div>

    </div>

    <!-- Footer -->
    <div class="cb-vertical-navigation-footer">
        <ng-content select="[bxVerticalNavigationFooter]"></ng-content>
    </div>

</div>

<!-- Aside -->
<div
    class="cb-vertical-navigation-aside-wrapper"
    *ngIf="activeAsideItemId"
    cbScrollbar
    [cbScrollbarOptions]="{wheelPropagation: false, suppressScrollX: true}"
    [@fadeInLeft]="position === 'left'"
    [@fadeInRight]="position === 'right'"
    [@fadeOutLeft]="position === 'left'"
    [@fadeOutRight]="position === 'right'">

    <!-- Items -->
    <ng-container *ngFor="let item of navigation; trackBy: trackByFn">

        <!-- Skip the hidden items -->
        <ng-container *ngIf="(item.hidden && !item.hidden(item)) || !item.hidden">

            <!-- Aside -->
            <cb-vertical-navigation-aside-item
                *ngIf="item.type === 'aside' && item.id === activeAsideItemId"
                [item]="item"
                [name]="name"
                [autoCollapse]="autoCollapse"></cb-vertical-navigation-aside-item>

        </ng-container>

    </ng-container>

</div>
